export default __webpack_public_path__ + "static/media/panthertest35.eaf63003.png";